const DEFAULT_REQ_TEXT = "This field is required";

export const isStrInputLen = (str) => {
  if (!str) return DEFAULT_REQ_TEXT;
  return !str.trim().length && DEFAULT_REQ_TEXT;
};

export const isNumValid = (num) => num === null && DEFAULT_REQ_TEXT;

export const noNamer = (firstName, lastName) => {
  const first = typeof firstName === "string" ? firstName.trim() : "";
  const last = typeof lastName === "string" ? lastName.trim() : "";

  return first || last ? [first, last].filter(Boolean).join(" ") : "No Name";
};
